import React from 'react';
import './FireLicensing.css'; // Create a CSS file for Fire Licensing specific styles if needed
import Header4 from '../../components/header/header4/Header4';
import ServicesHeroSection from '../../components/services_hero_section/ServicesHeroSection';
import backgroundimg from '../../assets/images/fire-1.jpg';
import Footer from '../../components/footer/Footer';
import ServicesOverviewSection from '../../components/services_overview_section/ServicesOverviewSection';
import img_fire_banner from '../../assets/images/img_peso1_banner.png'; // Replace with an appropriate image path
import { FaFireExtinguisher, FaGavel, FaShieldAlt, FaCogs, FaComments, FaFileAlt, FaPaperPlane, FaCertificate } from 'react-icons/fa';
import ServicesBenefitsSection from '../../components/services_benefits_section/ServicesBenefitsSection';
import ServicesOurProcessSection from '../../components/services_our_process_section/ServicesOurProcessSection';
import ActsAndRulesSection from '../../components/acts_rules_section/ActsAndRulesSection';
import DocumentChecklist from '../../components/check_list_section/CheckListSection';

export default function FireLicensing() {
  const fireBenefits = [
    {
      icon: <FaShieldAlt />,
      title: 'Enhanced Safety',
      text: 'Ensure fire safety compliance to protect lives and property.',
    },
    {
      icon: <FaGavel />,
      title: 'Legal Compliance',
      text: 'Avoid legal penalties by adhering to fire safety regulations.',
    },
    {
      icon: <FaCogs />,
      title: 'Operational Continuity',
      text: 'Prevent disruptions due to fire hazards with proper licensing.',
    },
    {
      icon: <FaFireExtinguisher />,
      title: 'Risk Mitigation',
      text: 'Minimize risks through certified fire safety practices.',
    },
  ];

  const steps = [
    {
      icon: <FaComments />,
      title: 'Initial Consultation',
      description: 'Discuss your requirements for fire safety compliance.',
    },
    {
      icon: <FaFileAlt />,
      title: 'Documentation Preparation',
      description: 'Prepare and gather all necessary fire safety documents.',
    },
    {
      icon: <FaShieldAlt />,
      title: 'Safety Assessment',
      description: 'Perform a thorough fire safety assessment of the premises.',
    },
    {
      icon: <FaPaperPlane />,
      title: 'Application Submission',
      description: 'Submit the fire licensing application and follow up.',
    },
    {
      icon: <FaCertificate />,
      title: 'Fire License Issuance',
      description: 'Receive your fire license approval and stay compliant.',
    },
  ];

  const acts = [
    'National Building Code (NBC)',
    'Fire Safety Act',
    'Local Fire Safety Regulations',
  ];

  const explanation =
    'These laws ensure that fire safety measures are implemented in buildings and operations to prevent accidents and comply with legal standards.';

  const checklistItems = [
    { name: 'Building Plan Approval', description: 'Submit approved building plans as per fire safety standards.' },
    { name: 'Fire Safety Equipment Details', description: 'Provide details of installed fire safety equipment.' },
    { name: 'Fire Safety Audit Report', description: 'Include the latest fire safety audit report.' },
    { name: 'No Objection Certificate (NOC)', description: 'Attach a copy of the NOC from the local fire authority.' },
  ];

  return (
    <>
      <Header4 />
      <ServicesHeroSection
        headline="Fire Licensing & Compliance"
        subheading="Ensure your premises meet fire safety standards with expert guidance."
        ctaPrimary={{ text: 'Request Consultation', link: '/contact-us' }}
        ctaSecondary={{ text: 'Learn More', link: '/fire-licensing' }}
        backgroundImage={backgroundimg } // Pass the background image here
      />

      <ServicesOverviewSection
        title="What is Fire Licensing?"
        description="Fire licensing is mandatory for ensuring safety and compliance with fire safety regulations. Our services streamline the process of obtaining and maintaining fire licenses."
        image={img_fire_banner} // Image for the fire licensing process
        altText="Fire Licensing Process"
      />

      <ServicesBenefitsSection
        title="Why You Need Fire Licensing"
        description="Discover the benefits of fire licensing for your safety and legal compliance."
        benefits={fireBenefits}
      />

      <ActsAndRulesSection
        title="Acts and Rules Covered"
        subtitle="Fire Safety and Compliance Regulations"
        acts={acts}
        explanation={explanation}
      />

      <ServicesOurProcessSection
        title="Our Simple Fire Licensing Process"
        steps={steps}
      />

      <DocumentChecklist
        mainTitle="Complete Your Onboarding"
        checklistTitle="Fire Licensing Onboarding Document Checklist"
        items={checklistItems}
      />

      <Footer />
    </>
  );
}
